DIRECTIVE_DEFINITION